<!-- ========== Switcher  ========== -->
<div id="hs-overlay-switcher" class="hs-overlay hidden ti-offcanvas ti-offcanvas-right" tabindex="-1">
  <div class="ti-offcanvas-header z-10 relative">
    <h5 class="ti-offcanvas-title">
      Switcher
    </h5>
    <button type="button"
      class="ti-btn flex-shrink-0 p-0 !mb-0  transition-none text-defaulttextcolor dark:text-defaulttextcolor/80 hover:text-gray-700 focus:ring-gray-400 focus:ring-offset-white  dark:hover:text-white/80 dark:focus:ring-white/10 dark:focus:ring-offset-white/10"
      data-hs-overlay="#hs-overlay-switcher">
      <span class="sr-only">Close modal</span>
      <i class="ri-close-circle-line leading-none text-lg"></i>
    </button>
  </div>
  <div class="ti-offcanvas-body !p-0 !border-b dark:border-white/10 z-10 relative !h-auto">
    <div class="flex rtl:space-x-reverse" aria-label="Tabs" role="tablist">
      <button type="button"
        class="hs-tab-active:bg-danger/20 w-full !py-2 !px-4 hs-tab-active:border-b-transparent text-[0.813rem] border-0 hs-tab-active:text-danger dark:hs-tab-active:bg-danger/20 dark:hs-tab-active:border-b-white/10 dark:hs-tab-active:text-danger -mb-px bg-white font-normal text-center  text-defaulttextcolor dark:text-defaulttextcolor/80 rounded-none hover:text-gray-700 dark:bg-bodybg dark:border-white/10  active"
        id="switcher-item-1" data-hs-tab="#switcher-1" aria-controls="switcher-1" role="tab">
        Theme Style
      </button>
      <button type="button"
        class="hs-tab-active:bg-danger/20 w-full !py-2 !px-4 hs-tab-active:border-b-transparent text-[0.813rem] border-0 hs-tab-active:text-danger dark:hs-tab-active:bg-danger/20 dark:hs-tab-active:border-b-white/10 dark:hs-tab-active:text-danger -mb-px  bg-white font-normal text-center  text-defaulttextcolor dark:text-defaulttextcolor/80 rounded-none hover:text-gray-700 dark:bg-bodybg dark:border-white/10  dark:hover:text-gray-300"
        id="switcher-item-2" data-hs-tab="#switcher-2" aria-controls="switcher-2" role="tab">
        Theme Colors
      </button>
    </div>
  </div>
  <div class="ti-offcanvas-body" id="switcher-body">
    <div id="switcher-1" role="tabpanel" aria-labelledby="switcher-item-1" class="">
      <div class="">
        <p class="switcher-style-head">Theme Color Mode:</p>
        <div class="grid grid-cols-3 switcher-style">
          <div class="flex items-center">
            <input type="radio" name="theme-style" class="ti-form-radio" id="switcher-light-theme"
              (click)="updateTheme('light')" [checked]="localdata['theme']=='light'">
            <label for="switcher-light-theme"
              class="text-[0.813rem] text-defaulttextcolor dark:text-defaulttextcolor/80 ms-2 font-normal">Light</label>
          </div>
          <div class="flex items-center">
            <input type="radio" name="theme-style" class="ti-form-radio" id="switcher-dark-theme"
              (click)="updateTheme('dark')" [checked]="localdata['theme'] =='dark'">
            <label for="switcher-dark-theme"
              class="text-[0.813rem] text-defaulttextcolor dark:text-defaulttextcolor/80 ms-2 font-normal">Dark</label>
          </div>
        </div>
      </div>
      <div>
        <p class="switcher-style-head">Directions:</p>
        <div class="grid grid-cols-3  switcher-style">
          <div class="flex items-center">
            <input type="radio" name="direction" class="ti-form-radio" id="switcher-ltr"
              (click)="updateDirection('ltr')" [checked]="localdata['direction'] != 'rtl'">
            <label for="switcher-ltr"
              class="text-[0.813rem] text-defaulttextcolor dark:text-defaulttextcolor/80 ms-2  font-normal">LTR</label>
          </div>
          <div class="flex items-center">
            <input type="radio" name="direction" class="ti-form-radio" id="switcher-rtl"
              (click)="updateDirection('rtl')" [checked]="localdata['direction'] == 'rtl'">
            <label for="switcher-rtl"
              class="text-[0.813rem] text-defaulttextcolor dark:text-defaulttextcolor/80 ms-2  font-normal">RTL</label>
          </div>
        </div>
      </div>
      <div >
        <p class="switcher-style-head">Navigation Styles:</p>
        <div class="grid grid-cols-3  switcher-style">
          <div class="flex items-center">
            <input type="radio" name="navigation-style" class="ti-form-radio" id="switcher-vertical"
              (click)="updatemenuType('vertical')" [checked]="localdata['navigationStyles'] != 'horizontal'">
            <label for="switcher-vertical"
              class="text-[0.813rem] text-defaulttextcolor dark:text-defaulttextcolor/80 ms-2  font-normal">Vertical</label>
          </div>
          <div class="flex items-center">
            <input type="radio" name="navigation-style" class="ti-form-radio" id="switcher-horizontal"
              [checked]="localdata['navigationStyles'] == 'horizontal'" (click)="updatemenuType('horizontal')">
            <label for="switcher-horizontal"
              class="text-[0.813rem] text-defaulttextcolor dark:text-defaulttextcolor/80 ms-2  font-normal">Horizontal</label>
          </div>
        </div>
      </div>
      <div class="navigation-menu-styles">
        <p class="switcher-style-head">Navigation Menu Style:</p>
        <div class="grid grid-cols-2 gap-2 switcher-style">
          <div class="flex">
            <input type="radio" name="navigation-data-menu-styles" class="ti-form-radio" id="switcher-menu-click"
              (click)="updatemenuStyle('menu-click')" [checked]="localdata['menuStyles'] == 'menu-click'">
            <label for="switcher-menu-click"
              class="text-[0.813rem] text-defaulttextcolor dark:text-defaulttextcolor/80 ms-2  font-normal">Menu
              Click</label>
          </div>
          <div class="flex">
            <input type="radio" name="navigation-data-menu-styles" class="ti-form-radio" id="switcher-menu-hover"
              (click)="updatemenuStyle('menu-hover')" [checked]="localdata['menuStyles'] == 'menu-hover'">
            <label for="switcher-menu-hover"
              class="text-[0.813rem] text-defaulttextcolor dark:text-defaulttextcolor/80 ms-2  font-normal">Menu
              Hover</label>
          </div>
          <div class="flex">
            <input type="radio" name="navigation-data-menu-styles" class="ti-form-radio" id="switcher-icon-click"
              (click)="updatemenuStyle('icon-click')" [checked]="localdata['menuStyles'] == 'icon-click'">
            <label for="switcher-icon-click"
              class="text-[0.813rem] text-defaulttextcolor dark:text-defaulttextcolor/80 ms-2  font-normal">Icon
              Click</label>
          </div>
          <div class="flex">
            <input type="radio" name="navigation-data-menu-styles" class="ti-form-radio" id="switcher-icon-hover"
              (click)="updatemenuStyle('icon-hover')" [checked]="localdata['menuStyles'] == 'icon-hover'">
            <label for="switcher-icon-hover"
              class="text-[0.813rem] text-defaulttextcolor dark:text-defaulttextcolor/80 ms-2  font-normal">Icon
              Hover</label>
          </div>
        </div>
      </div>
      <div class=" sidemenu-layout-styles">
        <p class="switcher-style-head">Sidemenu Layout Syles:</p>
        <div class="grid grid-cols-2 gap-2 switcher-style">
          <div class="flex">
            <input type="radio" name="sidemenu-layout-styles" class="ti-form-radio" id="switcher-default-menu"
              (click)="updatelayoutStyles('default')" checked>
            <label for="switcher-default-menu"
              class="text-[0.813rem] text-defaulttextcolor dark:text-defaulttextcolor/80 ms-2  font-normal ">Default
              Menu</label>
          </div>
          <div class="flex">
            <input type="radio" name="sidemenu-layout-styles" class="ti-form-radio" id="switcher-closed-menu"
              (click)="updatelayoutStyles('closed')" [checked]="localdata['layoutStyles'] == 'closed'">
            <label for="switcher-closed-menu"
              class="text-[0.813rem] text-defaulttextcolor dark:text-defaulttextcolor/80 ms-2  font-normal ">
              Closed
              Menu</label>
          </div>
          <div class="flex">
            <input type="radio" name="sidemenu-layout-styles" class="ti-form-radio" id="switcher-icontext-menu"
              (click)="updatelayoutStyles('icontext')" [checked]="localdata['layoutStyles'] == 'icontext'">
            <label for="switcher-icontext-menu"
              class="text-[0.813rem] text-defaulttextcolor dark:text-defaulttextcolor/80 ms-2  font-normal ">Icon
              Text</label>
          </div>
          <div class="flex">
            <input type="radio" name="sidemenu-layout-styles" class="ti-form-radio" id="switcher-icon-overlay"
              (click)="updatelayoutStyles('overlay')" [checked]="localdata['layoutStyles'] == 'overlay'">
            <label for="switcher-icon-overlay"
              class="text-[0.813rem] text-defaulttextcolor dark:text-defaulttextcolor/80 ms-2  font-normal ">Icon
              Overlay</label>
          </div>
          <div class="flex">
            <input type="radio" name="sidemenu-layout-styles" class="ti-form-radio" id="switcher-detached"
              (click)="updatelayoutStyles('detached')" [checked]="localdata['layoutStyles'] == 'detached'">
            <label for="switcher-detached"
              class="text-[0.813rem] text-defaulttextcolor dark:text-defaulttextcolor/80 ms-2  font-normal ">Detached</label>
          </div>
          <div class="flex">
            <input type="radio" name="sidemenu-layout-styles" class="ti-form-radio" id="switcher-double-menu"
              (click)="updatelayoutStyles('doublemenu')" [checked]="localdata['layoutStyles'] == 'doublemenu'">
            <label for="switcher-double-menu"
              class="text-[0.813rem] text-defaulttextcolor dark:text-defaulttextcolor/80 ms-2  font-normal">Double
              Menu</label>
          </div>
        </div>
      </div>
      <div>
        <p class="switcher-style-head">Page Styles:</p>
        <div class="grid grid-cols-3  switcher-style">
          <div class="flex">
            <input type="radio" name="data-page-styles" class="ti-form-radio" id="switcher-regular"
              (click)="updatepageStyles('regular')" [checked]="localdata['pageStyles'] != 'classic'">
            <label for="switcher-regular"
              class="text-[0.813rem] text-defaulttextcolor dark:text-defaulttextcolor/80 ms-2  font-normal">Regular</label>
          </div>
          <div class="flex">
            <input type="radio" name="data-page-styles" class="ti-form-radio" id="switcher-classic"
              (click)="updatepageStyles('classic')" [checked]="localdata['pageStyles'] == 'classic'">
            <label for="switcher-classic"
              class="text-[0.813rem] text-defaulttextcolor dark:text-defaulttextcolor/80 ms-2  font-normal">Classic</label>
          </div>
          <div class="flex">
            <input type="radio" name="data-page-styles" class="ti-form-radio" id="switcher-modern"
              (click)="updatepageStyles('modern')" [checked]="localdata['pageStyles'] == 'modern'">
            <label for="switcher-modern"
              class="text-[0.813rem] text-defaulttextcolor dark:text-defaulttextcolor/80 ms-2  font-normal">
              Modern</label>
          </div>
        </div>
      </div>
      <div>
        <p class="switcher-style-head">Layout Width Styles:</p>
        <div class="grid grid-cols-3 switcher-style">
          <div class="flex">
            <input type="radio" name="layout-width" class="ti-form-radio" id="switcher-default-width"
              (click)="updatewidthStyles('default')" [checked]="localdata['widthStyles'] == 'default'">
            <label for="switcher-default-width"
              class="text-[0.813rem] text-defaulttextcolor dark:text-defaulttextcolor/80 ms-2  font-normal">Default</label>
          </div>
          <div class="flex">
            <input type="radio" name="layout-width" class="ti-form-radio" id="switcher-full-width"
              (click)="updatewidthStyles('full-width')" [checked]="localdata['widthStyles'] == 'full-width'">
            <label for="switcher-full-width"
              class="text-[0.813rem] text-defaulttextcolor dark:text-defaulttextcolor/80 ms-2  font-normal">FullWidth</label>
          </div>
          <div class="flex">
            <input type="radio" name="layout-width" class="ti-form-radio" id="switcher-boxed"
              (click)="updatewidthStyles('boxed')" [checked]="localdata['widthStyles'] == 'boxed'">
            <label for="switcher-boxed"
              class="text-[0.813rem] text-defaulttextcolor dark:text-defaulttextcolor/80 ms-2  font-normal">Boxed</label>
          </div>
        </div>
      </div>
      <div>
        <p class="switcher-style-head">Menu Positions:</p>
        <div class="grid grid-cols-3  switcher-style">
          <div class="flex">
            <input type="radio" name="data-menu-positions" class="ti-form-radio" id="switcher-menu-fixed"
              (click)="updatemenuPosition('fixed')" [checked]="localdata['menuPosition'] != 'scrollable'">
            <label for="switcher-menu-fixed"
              class="text-[0.813rem] text-defaulttextcolor dark:text-defaulttextcolor/80 ms-2  font-normal">Fixed</label>
          </div>
          <div class="flex">
            <input type="radio" name="data-menu-positions" class="ti-form-radio" id="switcher-menu-scroll"
              (click)="updatemenuPosition('scrollable')" [checked]="localdata['menuPosition'] == 'scrollable'">
            <label for="switcher-menu-scroll"
              class="text-[0.813rem] text-defaulttextcolor dark:text-defaulttextcolor/80 ms-2  font-normal">Scrollable
            </label>
          </div>
        </div>
      </div>
      <div>
        <p class="switcher-style-head">Header Positions:</p>
        <div class="grid grid-cols-3 switcher-style">
          <div class="flex">
            <input type="radio" name="data-header-positions" class="ti-form-radio" id="switcher-header-fixed"
              (click)="updateheaderPosition('fixed')" [checked]="localdata['headerPosition'] != 'scrollable'">
            <label for="switcher-header-fixed"
              class="text-[0.813rem] text-defaulttextcolor dark:text-defaulttextcolor/80 ms-2  font-normal">
              Fixed</label>
          </div>
          <div class="flex">
            <input type="radio" name="data-header-positions" class="ti-form-radio" id="switcher-header-scroll"
              (click)="updateheaderPosition('scrollable')" [checked]="localdata['headerPosition'] == 'scrollable'">
            <label for="switcher-header-scroll"
              class="text-[0.813rem] text-defaulttextcolor dark:text-defaulttextcolor/80 ms-2  font-normal">Scrollable
            </label>
          </div>
        </div>
      </div>
 
    </div>
    <div id="switcher-2" class="hidden" role="tabpanel" aria-labelledby="switcher-item-2">
      <div class="theme-colors">
        <p class="switcher-style-head">Menu Colors:</p>
        <div class="flex switcher-style space-x-3 rtl:space-x-reverse">
          <div class="hs-tooltip ti-main-tooltip ti-form-radio switch-select ">
            <input class="hs-tooltip-toggle ti-form-radio color-input color-white" type="radio" name="menu-colors"
              (click)="updatemenuColor('light')" [checked]="localdata['menuColor'] == 'light'" id="switcher-menu-light"
              checked>
            <span
              class="hs-tooltip-content ti-main-tooltip-content !py-1 !px-2 !bg-black text-xs font-medium !text-white shadow-sm dark:!bg-black"
              role="tooltip">
              Light Menu
            </span>
          </div>
          <div class="hs-tooltip ti-main-tooltip ti-form-radio switch-select ">
            <input class="hs-tooltip-toggle ti-form-radio color-input color-dark" type="radio" name="menu-colors"
              (click)="updatemenuColor('dark')" [checked]="localdata['menuColor'] == 'dark'" id="switcher-menu-dark">
            <span
              class="hs-tooltip-content ti-main-tooltip-content !py-1 !px-2 !bg-black text-xs font-medium !text-white shadow-sm dark:!bg-black"
              role="tooltip">
              Dark Menu
            </span>
          </div>
          <div class="hs-tooltip ti-main-tooltip ti-form-radio switch-select ">
            <input class="hs-tooltip-toggle ti-form-radio color-input color-primary" type="radio" name="menu-colors"
              (click)="updatemenuColor('color')" [checked]="localdata['menuColor'] == 'color'"
              id="switcher-menu-primary">
            <span
              class="hs-tooltip-content ti-main-tooltip-content !py-1 !px-2 !bg-black text-xs font-medium !text-white shadow-sm dark:!bg-black"
              role="tooltip">
              Color Menu
            </span>
          </div>
          <div class="hs-tooltip ti-main-tooltip ti-form-radio switch-select ">
            <input class="hs-tooltip-toggle ti-form-radio color-input color-gradient" type="radio" name="menu-colors"
              (click)="updatemenuColor('gradient')" [checked]="localdata['menuColor'] == 'gradient'"
              id="switcher-menu-gradient">
            <span
              class="hs-tooltip-content ti-main-tooltip-content !py-1 !px-2 !bg-black text-xs font-medium !text-white shadow-sm dark:!bg-black"
              role="tooltip">
              Gradient Menu
            </span>
          </div>
          <div class="hs-tooltip ti-main-tooltip ti-form-radio switch-select ">
            <input class="hs-tooltip-toggle ti-form-radio color-input color-transparent" type="radio" name="menu-colors"
              (click)="updatemenuColor('transparent')" [checked]="localdata['menuColor'] == 'transparent'"
              id="switcher-menu-transparent">
            <span
              class="hs-tooltip-content ti-main-tooltip-content !py-1 !px-2 !bg-black text-xs !font-medium !text-white shadow-sm dark:!bg-black"
              role="tooltip">
              Transparent Menu
            </span>
          </div>
        </div>
        <div class="px-4 text-textmuted dark:text-textmuted/50 text-[.6875rem]"><b class="me-2 font-normal">Note:</b>If
          you want to change color Menu
          dynamically
          change from below Theme Primary color picker.</div>
      </div>
      <div class="theme-colors">
        <p class="switcher-style-head">Header Colors:</p>
        <div class="flex switcher-style space-x-3 rtl:space-x-reverse">
          <div class="hs-tooltip ti-main-tooltip ti-form-radio switch-select ">
            <input class="hs-tooltip-toggle ti-form-radio color-input color-white !border" type="radio"
              name="header-colors" (click)="updateheaderColor('light')" [checked]="localdata['headerColor'] == 'light'"
              id="switcher-header-light">
            <span
              class="hs-tooltip-content ti-main-tooltip-content !py-1 !px-2 !bg-black text-xs font-medium !text-white shadow-sm dark:!bg-black"
              role="tooltip">
              Light Header
            </span>
          </div>
          <div class="hs-tooltip ti-main-tooltip ti-form-radio switch-select ">
            <input class="hs-tooltip-toggle ti-form-radio color-input color-dark" type="radio" name="header-colors"
              (click)="updateheaderColor('dark')" [checked]="localdata['headerColor'] == 'dark'"
              id="switcher-header-dark">
            <span
              class="hs-tooltip-content ti-main-tooltip-content !py-1 !px-2 !bg-black text-xs font-medium !text-white shadow-sm dark:!bg-black"
              role="tooltip">
              Dark Header
            </span>
          </div>
          <div class="hs-tooltip ti-main-tooltip ti-form-radio switch-select ">
            <input class="hs-tooltip-toggle ti-form-radio color-input color-primary" type="radio" name="header-colors"
              (click)="updateheaderColor('color')" [checked]="localdata['headerColor'] == 'color'"
              id="switcher-header-primary">
            <span
              class="hs-tooltip-content ti-main-tooltip-content !py-1 !px-2 !bg-black text-xs font-medium !text-white shadow-sm dark:!bg-black"
              role="tooltip">
              Color Header
            </span>
          </div>
          <div class="hs-tooltip ti-main-tooltip ti-form-radio switch-select ">
            <input class="hs-tooltip-toggle ti-form-radio color-input color-gradient" type="radio" name="header-colors"
              (click)="updateheaderColor('gradient')" [checked]="localdata['headerColor'] == 'gradient'"
              id="switcher-header-gradient">
            <span
              class="hs-tooltip-content ti-main-tooltip-content !py-1 !px-2 !bg-black text-xs font-medium !text-white shadow-sm dark:!bg-black"
              role="tooltip">
              Gradient Header
            </span>
          </div>
          <div class="hs-tooltip ti-main-tooltip ti-form-radio switch-select ">
            <input class="hs-tooltip-toggle ti-form-radio color-input color-transparent" type="radio"
              name="header-colors" id="switcher-header-transparent" (click)="updateheaderColor('transparent')"
              [checked]="localdata['headerColor'] == 'transparent'">
            <span
              class="hs-tooltip-content ti-main-tooltip-content !py-1 !px-2 !bg-black text-xs font-medium !text-white shadow-sm dark:!bg-black"
              role="tooltip">
              Transparent Header
            </span>
          </div>
        </div>
        <div class="px-4 text-textmuted dark:text-textmuted/50 text-[.6875rem]"><b class="me-2 !font-normal">Note:</b>If
          you want to change color
          Header dynamically
          change from below Theme Primary color picker.</div>
      </div>
      <div class="theme-colors">
        <p class="switcher-style-head">Theme Primary:</p>
        <div class="flex switcher-style space-x-3 rtl:space-x-reverse">
          <div class="ti-form-radio switch-select">
            <input class="ti-form-radio color-input color-primary-1" type="radio" name="theme-primary"
              id="switcher-primary" (click)="
                updateprimary({
                  primary: '106, 91, 204', primary1: '106 91 204'
                })
              ">
          </div>
          <div class="ti-form-radio switch-select">
            <input class="ti-form-radio color-input color-primary-2" type="radio" name="theme-primary" (click)="updateprimary({
                primary: '100, 149, 237', primary1: '100 149 237'
              }) " [checked]="localdata['themePrimary'] == '100, 149, 237'" id="switcher-primary1">
          </div>
          <div class="ti-form-radio switch-select">
            <input class="ti-form-radio color-input color-primary-3" type="radio" name="theme-primary" (click)="
              updateprimary({
                primary: '0, 123, 167', primary1: '0 123 167'
              })
            " [checked]="localdata['themePrimary'] == '0, 123, 167'" id="switcher-primary2">
          </div>
          <div class="ti-form-radio switch-select">
            <input class="ti-form-radio color-input color-primary-4" type="radio" name="theme-primary" (click)="  updateprimary({
                primary: '10, 180, 255', primary1: '10 180 255'
              })
            " [checked]="localdata['themePrimary'] == '10, 180, 255'" id="switcher-primary3">
          </div>
          <div class="ti-form-radio switch-select">
            <input class="ti-form-radio color-input color-primary-5" type="radio" name="theme-primary" (click)="  updateprimary({
                primary: '46, 81, 145', primary1: '46 123 167'
              })
            " [checked]="localdata['themePrimary'] == '46, 81, 145'" id="switcher-primary4">
          </div>
          <div class="ti-form-radio switch-select ps-0 color-primary-light">
            <div class="theme-container-primary"></div>
            <div class="pickr-container-primary">
              <div class="pickr">
                <button type="button" role="button" aria-label="toggle color picker dialog"
                  class="color-bg-transparent pcr-button" style="--pcr-color: rgba(132, 90, 223, 1);"
                  [style.background]="defaultPrimary" [cpAlphaChannel]="'disabled'" [cpOutputFormat]="'rgba'"
                  [(colorPicker)]="defaultPrimary" (cpSliderDragEnd)="dynamicLightPrimary($event)"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="theme-colors">
        <p class="switcher-style-head">Theme Background:</p>
        <div class="flex switcher-style space-x-3 rtl:space-x-reverse">
          <div class="ti-form-radio switch-select">
            <input class="ti-form-radio color-input color-bg-1" type="radio" name="theme-background"
              id="switcher-background" (click)="
                updateBackground({
                  main: '49 63 141',
                  secondary: '54 71 146',
                  accent: '54 71 146',
                  overlay: 'rgba(255,255,255,0.1)',
                  theme: 'dark'
                })
              " [checked]="localdata['themeBackground']?.['main'] == '49 63 141'">
          </div>
          <div class="ti-form-radio switch-select">
            <input class="ti-form-radio color-input color-bg-2" type="radio" name="theme-background"
              id="switcher-background1" (click)="
                updateBackground({
                  main: '46 94 184',
                  secondary: '51 102 189',
                  accent: '51 102 189',
                  overlay: 'rgba(255,255,255,0.1)',
                  theme: 'dark'
                })
              " [checked]="localdata['themeBackground']?.['main'] == '46 94 184'">
          </div>
          <div class="ti-form-radio switch-select">
            <input class="ti-form-radio color-input color-bg-3" type="radio" name="theme-background" (click)="
              updateBackground({
                main: '23 74 105',
                secondary: '28 82 110',
                accent: '28 82 110',
                overlay: 'rgba(255,255,255,0.1)',
                theme: 'dark'
              })
            " [checked]="localdata['themeBackground']?.['main'] == '23 74 105'" id="switcher-background2">
          </div>
          <div class="ti-form-radio switch-select">
            <input class="ti-form-radio color-input color-bg-4" type="radio" name="theme-background"
              id="switcher-background3" (click)="
                updateBackground({
                  main: '34 120 174',
                  secondary: '39 128 179',
                  accent: '39 128 179',
                  overlay: 'rgba(255,255,255,0.1)',
                  theme: 'dark'
                })
              " [checked]="localdata['themeBackground']?.['main'] == '34 120 174'">
          </div>
          <div class="ti-form-radio switch-select">
            <input class="ti-form-radio color-input color-bg-5" type="radio" name="theme-background"
              id="switcher-background4" (click)="
                updateBackground({
                  main: '12 23 91',
                  secondary: '17 31 96',
                  accent: '17 31 96',
                  overlay: 'rgba(255,255,255,0.1)',
                  theme: 'dark'
                })
              " [checked]="localdata['themeBackground']?.['main'] == '12 23 91'">
          </div>
          <div class="ti-form-radio switch-select ps-0 color-bg-transparent">
            <div class="theme-container-background hidden"></div>
            <div class="pickr-container-background">
              <div class="pickr">
                <button type="button" role="button" aria-label="toggle color picker dialog"
                  class="color-bg-transparent pcr-button" style="--pcr-color: rgba(132, 90, 223, 1)"
                  [style.background]="defaultBg" [cpAlphaChannel]="'disabled'" [cpOutputFormat]="'rgba'"
                  [(colorPicker)]="defaultBg" (cpSliderDragEnd)="dynamicTranparentBgPrimary($event)"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="menu-image theme-colors">
        <p class="switcher-style-head">Menu With Background Image:</p>
        <div class="flex switcher-style space-x-3 rtl:space-x-reverse flex-wrap gap-3">
          <div class="ti-form-radio switch-select">
            <input class="ti-form-radio bgimage-input bg-img1" (click)="updateBgImage('bgimg1')" type="radio"
              name="theme-images" id="switcher-bg-img">
          </div>
          <div class="ti-form-radio switch-select">
            <input class="ti-form-radio bgimage-input bg-img2" (click)="updateBgImage('bgimg2')" type="radio"
              name="theme-images" id="switcher-bg-img1">
          </div>
          <div class="ti-form-radio switch-select">
            <input class="ti-form-radio bgimage-input bg-img3" (click)="updateBgImage('bgimg3')" type="radio"
              name="theme-images" id="switcher-bg-img2">
          </div>
          <div class="ti-form-radio switch-select">
            <input class="ti-form-radio bgimage-input bg-img4" (click)="updateBgImage('bgimg4')" type="radio"
              name="theme-images" id="switcher-bg-img3">
          </div>
          <div class="ti-form-radio switch-select">
            <input class="ti-form-radio bgimage-input bg-img5" (click)="updateBgImage('bgimg5')" type="radio"
              name="theme-images" id="switcher-bg-img4">
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="ti-offcanvas-footer sm:flex justify-between">
    <a href="javascript:void(0);" (click)="reset()" id="reset-all" class="ti-btn ti-btn-danger w-full m-1">Reset</a>
  </div>
<!-- ========== END Switcher  ========== -->